import LegacySocialMediaFields from './components/LegacySocialMediaFields';
import SocialMediaFieldsV2 from './components/SocialMediaFields';
import { SocialAccount } from 'context/OnboardingContext';
import { DeepMap, FieldError } from 'react-hook-form';

type SocialMediaFieldsProps = {
  socialAccounts?: SocialAccount[];
  errors: DeepMap<SocialAccount[] | undefined, FieldError> | FieldError;
  onChange: (socialAccounts: SocialAccount[]) => void;
  isNewSocialMediaIntegration?: boolean;
};

const SocialMediaFields = (props: SocialMediaFieldsProps) => {
  if (props.isNewSocialMediaIntegration) {
    return <SocialMediaFieldsV2 {...props} />;
  }

  return (
    <div>
      <LegacySocialMediaFields {...props} />
    </div>
  );
};

export default SocialMediaFields;
